class SupernovaTeaser extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()

    this.bindTimer()
  }

  bindTimer () {
    const timer = this.els.countdown.element

    if (!timer) return

    this.date = Date.parse(timer.dataset.launchDate)

    this.interval = window.setInterval(this.updateTimer.bind(this), 1000)

    this.updateTimer()
  }

  updateTimer () {
    const remainingTime = this.date - new Date()

    if (remainingTime < 0) {
      window.clearInterval(this.interval)
      this.setEnded()
      return
    }

    const days = this.zeroPad(remainingTime / (1000 * 60 * 60 * 24))
    const hours = this.zeroPad(
      (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = this.zeroPad(
      (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
    )
    const seconds = this.zeroPad((remainingTime % (1000 * 60)) / 1000)

    this.els.countdown.element.innerText = this.formatCountdown(
      days,
      hours,
      minutes,
      seconds
    )
  }

  zeroPad (number) {
    return number < 10 ? `0${Math.floor(number)}` : Math.floor(number)
  }

  formatCountdown (days, hours, minutes, seconds) {
    if (days > 0) {
      return `${days}:${hours}:${minutes}:${seconds}`
    }

    return `${hours}:${minutes}:${seconds}`
  }

  setEnded () {
    this.els.countdown.element.innerText = 'Launched'
  }
}

if (!customElements.get('supernova-teaser')) {
  customElements.define('supernova-teaser', SupernovaTeaser)
}
